import { Button, DatePicker, message, Modal } from 'antd';
import { useFormik } from 'formik';
import moment from 'moment';
import React, { useState } from 'react';
import Item from '../../../components/Form/Item';
import axios from '../../../util/Api';

const PeriodUpdate = ({ item, passport }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const formik = useFormik({
    initialValues: {
      start: item.start_date,
      end: item.end_date
    },
    onSubmit: values => {
      const url = `/passport/period-update`;
      const data = {
        id: item.id,
        ...values,
      };
      axios.post(url, data).then(resp => {
        if (resp.data.success) {
          message.success("Periode telah berhasil diperbarui");
          window.location.reload();
        } else {
          message.error("Gagal memperbarui periode");
        }
      }).catch(err => {
        message.error("Gagal memperbarui periode");
      });
    }
  });

  const handleOk = () => {
    formik.submitForm();
  }

  const handleCancel = () => {
    setIsModalVisible(false);
  }

  return (
    <>
      <Button type="primary" ghost size="small" onClick={()=>setIsModalVisible(true)}>Edit Periode</Button>

      <Modal title="Update Periode Tanggal Masuk & Keluar" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} okButtonProps={{loading: formik.isSubmitting}}>
        <Item name="Tanggal Masuk" required>
          <DatePicker
            onChange={(value) => {
              formik.setFieldValue("start", value.format("YYYY-MM-DD"));
            }}
            style={{ width: 320 }}
          />
        </Item>
        <Item name="Berakhir" required>
          <DatePicker
            onChange={(value) => {
              formik.setFieldValue("end", value.format("YYYY-MM-DD"));
            }}
            style={{ width: 320 }}
            disabledDate={(current) => {
              return current && current < moment(new Date(formik.values.start)).endOf('day')
            }}
          />
        </Item>
      </Modal>
    </>
  );
}

export default PeriodUpdate;